module.exports = __webpack_public_path__ + "media/page-6.95dfd39c.mp3";